export enum RoutesEnum {
  PHARMACEUTICAL_LOGIN_PAGE = '/',
  PHARMACEUTICAL_PANEL_PAGE = '/panel/',
  PHARMACEUTICAL_SIGNUP = '/pharmaceutical/signup',
  PHARMACEUTICAL_PANEL_DASHBOARD = '/panel/dashboard',
  PHARMACEUTICAL_MY_DATA = '/panel/my-data',
  LOGOUT_ROUTE = '/api/auth/logout',
  CONTENTS_ROUTE = '/panel/contents',
  SCHEDULE_INDICATION_ROUTE = '/panel/schedule-indication',
  DISCOUNTS_ROUTE = '/panel/discounts',
  REGULATION_ROUTE = '/panel/regulation',
  MEDICINE_LEAFLETS_ROUTE = '/panel/medicine-leaflets',
  TERM_OF_ACCEPTANCE = '/termOfAcceptance',
}

// PORTAL API URL
export const {
  PORTAL_API_URL = 'http://localhost:3001/api',
} = process.env;

// BOEHRINGER CONFIGURATION
export const {
  BOEHRINGER_PROGRAM_CODE = '126',
} = process.env;

// ORIGIN CODE
export const {
  ORIGIN_CODE = '23',
} = process.env;
